import { Vue } from "vue-property-decorator";
/**
 * Parent class for store modules
 */
export default abstract class StoreModule<S> {
  protected abstract state: S;

  public getState(): S {
    return this.state;
  }

  protected setState(newState: Partial<S>) {
    return Object.assign(this.state, newState);
  }

  static bootstrap<T extends StoreModule<any>>(obj: T) {
    Vue.observable(obj.state);
    return obj;
  }

  static singleton<T extends StoreModule<any>>(
    klass: { new (...args: any[]): T },
    ...args: any[]
  ) {
    return StoreModule.bootstrap(new klass(args));
  }
}
